import { RadioTextFilterOperation } from '@hotjar/global-filters';
import { QueryKeyEnum } from '@hotjar/global-filters/src/domains/global-filters/model/QueryFormat';
import type { RadioTextFilterValueType } from '@hotjar/global-filters';
import { UserAttributeQueryKind, UserAttributesFilter } from './UserAttributeFilters';

import type {
  UserAttributeClauseNameless,
  UserAttributeWithKindType,
} from './UserAttributeFilters';

export const mapStringUserAttribute = (
  filter: RadioTextFilterValueType,
): UserAttributeClauseNameless => {
  const type: UserAttributeWithKindType = `${QueryKeyEnum.user_attributes}.${UserAttributeQueryKind.STR}`;

  switch (filter?.operation) {
    case RadioTextFilterOperation.CONTAINS:
      return { type, operation: UserAttributesFilter.CONTAINS, value: filter.value };
    case RadioTextFilterOperation.NOT_CONTAINS:
      return { type, operation: UserAttributesFilter.NOT_CONTAINS, value: filter.value };
    case RadioTextFilterOperation.IS:
      return { type, operation: UserAttributesFilter.EQUALS, value: filter.value };
    case RadioTextFilterOperation.IS_NOT:
      return { type, operation: UserAttributesFilter.NOT_EQUALS, value: filter.value };
    case RadioTextFilterOperation.STARTS_WITH:
      return { type, operation: UserAttributesFilter.STARTS_WITH, value: filter.value };
    case RadioTextFilterOperation.ENDS_WITH:
      return { type, operation: UserAttributesFilter.ENDS_WITH, value: filter.value };
    case RadioTextFilterOperation.IS_UNKNOWN:
      return { type, operation: UserAttributesFilter.IS_UNKNOWN };
    case RadioTextFilterOperation.HAS_ANY_VALUE:
    default:
      return { type, operation: UserAttributesFilter.HAS_ANY_VALUE };
  }
};
